import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  constructor() {

  }
  
  ngOnInit() {
    function load_js() {
       var head = document.getElementsByTagName('head')[0];
       var script = document.createElement('script');
       script.src = 'https://apps.elfsight.com/p/platform.js';
       head.appendChild(script);
    }
    load_js();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/profile/profile.component.ts